/* eslint-disable import/no-unresolved */
import {
    Button,
} from 'appkit-react';
import {
    Card, Col, Row,
} from 'react-bootstrap';

import DefaultAlert from 'views/Shared/components/DefaultAlert';
import CreateProjectModal from '../../Projects/CreateProjectModal/CreateProjectModal';
import FileExplorerContainer from '../../FileExplorer/containers/FileExplorerContainer';
import ProjectListContainer from '../containers/ProjectListContainer';
import '../styles/home.scss';

const cardWidth = 'content-fit';

const Home = ({
    loggedUserId, tenantId, mainDataProjectData, refetchProjectHierarchy,
    projectHierarchyIsLoading, projectHierarchyIsError, showCreateProjectModal,
    setShowCreateProjectModal, navigateToProjectTab, projectCount, toastMessage, setToastMessage,
}) => (
    <div className="true-comply-reporting-data-recon-home">
        {toastMessage
            && (
                <DefaultAlert
                    status="success"
                    toastMessage={toastMessage}
                    setToastMessage={setToastMessage}
                />
            )}
        <Row>
            <Col>
                <h3>Home</h3>
            </Col>
            <Col>
                <Button size="lg" className="create-Project-btn" onClick={() => setShowCreateProjectModal(true)}>
                    <span className="appkiticon icon-plus-fill" />
                    CREATE PROJECT
                </Button>
            </Col>
            {showCreateProjectModal
                && (
                    <CreateProjectModal
                        visibleFlag={showCreateProjectModal}
                        setShowModal={setShowCreateProjectModal}
                        tenantId={tenantId}
                        fetchData={refetchProjectHierarchy}
                        setCopyProjectFlag={() => { }}
                        setToastMessage={setToastMessage}
                    />
                )}
        </Row>
        <Row style={{ marginTop: '1rem', marginBottom: '0.5rem' }}>
            <Col md={4} style={{ paddingLeft: 0 }}>
                <Card
                    className="mb-2"
                    style={{ width: cardWidth, marginLeft: '0.9rem' }}
                >
                    <Card.Body style={{ paddingRight: 0 }}>
                        <Card.Title>
                            <Row>
                                <Col md={1}>
                                    <span className="appkiticon icon-revenue-outline" style={{ color: 'black', fontSize: '2rem' }} />
                                </Col>
                                <Col>
                                    <span className="a-h4" style={{ paddingLeft: '0.5rem' }}> DATA RECONCILIATION</span>
                                </Col>
                            </Row>
                        </Card.Title>
                        <Card.Text>
                            <span
                                style={{
                                    marginBottom: '0.5rem', display: 'block',
                                }}
                                className="a-h5"
                            >
                                {projectHierarchyIsLoading && <span className="a-loading a-primary a-m-10 a-loading-8" style={{ width: '1.3rem', height: '1.3rem' }} />}
                                {projectCount && projectCount.total}
                                {!projectHierarchyIsLoading && <span style={{ marginLeft: '0.3rem' }}>Projects</span>}
                            </span>
                            <span
                                style={{
                                    color: `${projectCount && projectCount.total > 0 ? '#d04a02' : 'gray'}`,
                                    fontSize: '0.8rem',
                                    fontWeight: 'bold',
                                    cursor: `${projectCount && projectCount.total > 0 ? 'pointer' : ''}`,
                                }}
                                onClick={() => projectCount && projectCount.total > 0 && navigateToProjectTab('ALL')}
                                role="presentation"
                            >
                                VIEW ALL
                            </span>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card
                    className="mb-2"
                    style={{ width: cardWidth }}
                >
                    <Card.Body>
                        <Card.Title>
                            <Row>
                                <Col md={1}>
                                    <span className="appkiticon icon-circle-checkmark-outline" style={{ marginRight: '0.5rem', fontSize: '2rem' }} />
                                </Col>
                                <Col>
                                    <span className="a-h4" style={{ paddingLeft: '0.8rem' }}>COMPLETE</span>
                                </Col>
                            </Row>
                        </Card.Title>
                        <Card.Text>
                            <span
                                style={{
                                    marginBottom: '0.5rem', display: 'block',
                                }}
                                className="a-h5"
                            >
                                {projectCount && projectCount.completed}
                                {!projectHierarchyIsLoading && <span style={{ marginLeft: '0.3rem' }}>Resolved</span>}

                                {projectHierarchyIsLoading && <span className="a-loading a-primary a-m-10 a-loading-8" style={{ width: '1.3rem', height: '1.3rem' }} />}
                            </span>
                            <span
                                style={{
                                    color: `${projectCount && projectCount.completed > 0 ? '#d04a02' : 'gray'}`,
                                    fontSize: '0.8rem',
                                    fontWeight: 'bold',
                                    cursor: `${projectCount && projectCount.completed > 0 ? 'pointer' : ''}`,
                                }}
                                onClick={() => projectCount && projectCount.completed > 0 && navigateToProjectTab('COMPLETED')}
                                role="presentation"
                            >
                                VIEW ALL
                            </span>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card
                    className="mb-2"
                    style={{ width: cardWidth }}
                >
                    <Card.Body>
                        <Card.Title>

                            <Row>
                                <Col md={1}>
                                    <span
                                        className="appkiticon icon-circle-delete-outline"
                                        style={{ marginRight: '0.5rem', fontSize: '2rem' }}
                                    />
                                </Col>
                                <Col>
                                    <span className="a-h4" style={{ paddingLeft: '0.8rem' }}>FAILED</span>
                                </Col>
                            </Row>
                        </Card.Title>
                        <Card.Text>
                            <span
                                style={{
                                    marginBottom: '0.5rem', display: 'block',
                                }}
                                className="a-h5"
                            >
                                {projectCount && projectCount.failed}
                                {!projectHierarchyIsLoading && <span style={{ marginLeft: '0.3rem' }}>Unsuccessful</span>}
                                {projectHierarchyIsLoading && <span className="a-loading a-primary a-m-10 a-loading-8" style={{ width: '1.3rem', height: '1.3rem' }} />}
                            </span>
                            <span
                                style={{
                                    color: `${projectCount && projectCount.failed > 0 ? '#d04a02' : 'gray'}`,
                                    fontSize: '0.8rem',
                                    fontWeight: 'bold',
                                    cursor: `${projectCount && projectCount.failed > 0 ? 'pointer' : ''}`,
                                }}
                                onClick={() => projectCount && projectCount.failed > 0 && navigateToProjectTab('FAILED')}
                                role="presentation"
                            >
                                VIEW ALL
                            </span>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card
                    className="mb-2"
                    style={{ width: cardWidth }}
                >
                    <Card.Body>
                        <Card.Title>

                            <Row>
                                <Col md={1}>
                                    <span
                                        className="appkiticon icon-list-view-outline"
                                        style={{ marginRight: '0.5rem', fontSize: '2rem' }}
                                    />
                                </Col>
                                <Col>
                                    <span className="a-h4" style={{ paddingLeft: '0.8rem' }}>IN PROGRESS</span>
                                </Col>
                            </Row>
                        </Card.Title>
                        <Card.Text>
                            <span
                                style={{
                                    marginBottom: '0.5rem', display: 'block',
                                }}
                                className="a-h5"
                            >
                                {projectCount && projectCount.inProgress}
                                {!projectHierarchyIsLoading && <span style={{ marginLeft: '0.3rem' }}>Proceeding</span>}
                                {projectHierarchyIsLoading
                                    && (
                                        <span
                                            className="a-loading a-primary a-m-10 a-loading-8"
                                            style={{ width: '1.3rem', height: '1.3rem' }}
                                        />
                                    )}
                            </span>
                            <span
                                style={{
                                    color: `${projectCount && projectCount.inProgress > 0 ? '#d04a02' : 'gray'}`,
                                    fontSize: '0.8rem',
                                    fontWeight: 'bold',
                                    cursor: `${projectCount && projectCount.inProgress > 0 ? 'pointer' : ''}`,
                                }}
                                onClick={() => projectCount && projectCount.inProgress > 0 && navigateToProjectTab('IN_PROGRESS')}
                                role="presentation"
                            >
                                VIEW ALL
                            </span>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
        </Row>

        <div style={{ paddingBottom: '2rem' }} className="data-recon-home-file-explorer">
            <FileExplorerContainer tenantId={tenantId} />
        </div>
        <div style={{ paddingBottom: '2rem' }}>
            <ProjectListContainer
                tenantId={tenantId}
                mainData={mainDataProjectData}
                refetchProjectHierarchy={refetchProjectHierarchy}
                projectHierarchyIsLoading={projectHierarchyIsLoading}
                projectHierarchyIsError={projectHierarchyIsError}
                setToastMessage={setToastMessage}
            />
        </div>
    </div>
);

export default Home;
